import React from 'react'
import { connect } from 'react-redux'
import browserHistory from 'helpers/history'
import { parse } from 'qs'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import generalActions from 'redux/actions/generalActions'
import redirectTo from 'helpers/redirection'

function Redirection(WrappedComponent) {
	const RedirectionComponent = class RedirectionComponent extends React.Component {

		componentDidMount() {
			if (this.props.user.logged === null) {
				this.props.actions.tryAutoLogin()
			}
		}

		componentWillReceiveProps(props) {
			if (props.user.logged === true && this.props.user.logged !== true) {
				if (props.user.data.redirectUrl) {
					this.props.actions.dismissRedirection()
				}
				redirectTo(props.user.data.redirectUrl, props.user)
			} else if (props.login.recoveryKey.value) {
				let url = '/new_password'
				const params = parse(location.search.substr(1))
				if (params.referer) {
					url += '?referer=' + encodeURIComponent(params.referer)
				}
				browserHistory.replace(url)
			}
		}

		render() {
			if (this.props.user.logged === false) {
				return <WrappedComponent {...this.props}/>
			}
			return null
		}
	}
	return connect(mapStateToProps, mapDispatchToProps)(RedirectionComponent)
}

function mapStateToProps(state) {
	return {
		user: state.user,
		login: state.login,
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		tryAutoLogin: generalActions.tryAutoLogin,
		dismissRedirection: generalActions.dismissRedirection,
	}, dispatch)
}

export default Redirection
